// The buyer's side of the Ägarbyte stage — the payment stage with the roles reversed.
//
// At the payment the buyer acts and the seller, who can see the money, confirms. Here the SELLER
// acts — the ownership transfer is reported in Transportstyrelsen's own service — and the buyer
// waits, on a screen that names who is acting and says there is nothing for the buyer to do.
//
// TRUTH: Klargo holds no answer from Transportstyrelsen. The stage says what the seller has
// stated, attributed to the seller, and what Transportstyrelsen does next. It never says the
// buyer is the registered owner.
//
// Nobody acts on this screen, so nothing settles in and nothing takes focus: the buyer is
// brought here by the seller's confirmation, which the payment stage already announced. The one
// animation is the waiting notice's own pulse (§7: waiting is slate, never celebration).
import React from "react";
import { DealWaitingNotice } from "../payment/PaymentParts";
import { H1_CLASS, LEAD_CLASS, META_CLASS, OwnershipKicker } from "./OwnershipParts";

export default function BuyerOwnershipPanel({ vars, t }) {
  return (
    <div data-testid="ownership-buyer-waiting">
      <OwnershipKicker reported={false} t={t} />
      <h1 className={H1_CLASS}>{t("ownership.buyer.title", vars)}</h1>
      <p className={LEAD_CLASS}>{t("ownership.buyer.lead", vars)}</p>
      <div className="mt-6 max-w-[58ch]">
        <DealWaitingNotice
          title={t("ownership.buyer.waiting.title", vars)}
          text={t("ownership.buyer.waiting.text", vars)}
          t={t}
        />
      </div>
      <p className={`${META_CLASS} mt-4`}>{t("ownership.buyer.meta", vars)}</p>
    </div>
  );
}
